import { useContext } from 'react';
import { UserContext } from 'src/context/userContext';
import { urlList } from 'src/context/url';

export interface OperatorActionConfig {
  action: string;
  id: string;
  operatorName: string;
}

export type OperatorActionType =
  | 'RETRY'
  | 'SUCCEEDEDOVERRIDE'
  | 'SKIPPEDOVERRIDE'
  | 'FAILEDOVERRIDE';

interface TriggerOperatorAction {
  operatorName: string;
  operatorFlowJobId: string;
  operatorAction: OperatorActionType;
}

export interface TriggerOperatorActionResponse extends TriggerOperatorAction {
  triggerStatus: 'SUCCEEDED' | 'FAILED';
}

export const useOperatorAction = (): {
  triggerOperatorAction: (
    operatorActionConfig: OperatorActionConfig,
  ) => Promise<TriggerOperatorActionResponse>;
} => {
  const user = useContext(UserContext);
  const triggerOperatorAction = (option: OperatorActionConfig) =>
    fetch(urlList.operatorAction, {
      method: 'POST',
      headers: {
        Authorization: user.token,
        'Content-type': 'application/json',
      },
      body: JSON.stringify({
        operatorFlowJobId: option.id,
        operatorName: option.operatorName,
        operatorAction: option.action.toUpperCase(),
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.message) throw new Error(res.message);
        if (res.triggerStatus === 'FAILED')
          throw new Error('Failed to request Operator Action');
        return res;
      });

  return { triggerOperatorAction };
};
